import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import Image from 'next/image';
import Link from 'next/link';
import { IPlugin } from '../../../types';
import { PopoverDiv } from './menuPopovers.styles';

interface IPopoverProps {
	isDark?: boolean;
	columns?: { title: string; apps: IPlugin[] }[];
	show?: boolean;
}

export const AppsPopover = ({ show, isDark, columns = [] }: IPopoverProps) => {
	return (
		<PopoverDiv className={`${isDark ? 'dark' : ''}  ${show ? 'show' : ''}`}>
			<div className={`apps`}>
				{columns.map((column, idx) => (
					<div className="column" key={column.title}>
						<p className="title">{column.title}</p>
						{column.apps.map((app) => (
							<Link
								className="widget"
								title={app.name}
								key={app.slug}
								href={`https://www.commoninja.com/widgets/${app.slug}?via=discover&utm_source=discover&utm_medium=referral&utm_campaign=${app.name}`}
							>
								<Image src={app.logo} alt={app.name} width={20} height={20} />
								{app.name}
							</Link>
						))}
					</div>
				))}
				<div className="column more">
					<p className="title">More</p>
					<Link
						href={
							'https://www.commoninja.com/widgets?utm_source=discover&utm_medium=referral&utm_campaign=widgets'
						}
					>
						See All Widgets
						<IoIosArrowForward fontSize={18} className="icon" />
					</Link>
					<Link
						href={
							'https://www.commoninja.com/platforms?utm_source=discover&utm_medium=referral&utm_campaign=platforms'
						}
					>
						See Platforms
						<IoIosArrowForward fontSize={18} className="icon" />
					</Link>
				</div>
			</div>
		</PopoverDiv>
	);
};

export const ResourcesPopover = ({ isDark, show }: IPopoverProps) => {
	return (
		<PopoverDiv className={`${isDark ? 'dark' : ''} ${show ? 'show' : ''}`}>
			<div className={`resources  ${isDark ? 'dark' : ''}`}>
				<Link href={'https://www.commoninja.com/blog'}>Blog</Link>
				<Link
					href={
						'https://help.commoninja.com/hc/en-us/community/topics/360000419337-Feature-Requests'
					}
					target="_blank"
				>
					Feature Request
				</Link>
				<Link
					href={
						'https://help.commoninja.com/hc/en-us/community/topics/360000419377-General-Discussion'
					}
					target="_blank"
				>
					Community Forum
				</Link>
				<Link href={'https://www.commoninja.com/affiliates'}>
					Affiliate Program
				</Link>
				<Link href={'https://docs.commoninja.com'} target="_blank">
					Developer Docs
				</Link>
				<Link href={'https://www.commoninja.com/write-for-us'}>
					Write for us
				</Link>
			</div>
		</PopoverDiv>
	);
};

export const SupportPopover = ({ isDark, show }: IPopoverProps) => {
	return (
		<PopoverDiv className={`${isDark ? 'dark' : ''} ${show ? 'show' : ''}`}>
			<div className={`support`}>
				<Link href={'https://help.commoninja.com/hc/en-us'} target="_blank">
					Help Center
				</Link>
				<Link href={'https://www.commoninja.com/contact-us'} target="_blank">
					Contact Us
				</Link>
			</div>
		</PopoverDiv>
	);
};
